import React, { useContext, useEffect, useState } from 'react'
import Title from './title'
import { ScrollBoard } from '@jiaminghi/data-view-react'
import useWindowDimensions from '../hook/window'
import { DataContext } from '../../App'

export default props => {
  const { height, width } = useWindowDimensions()

  let data = useContext(DataContext)
  let final_data = []
  if (data && data.recent_consumption_records && Array.isArray(data.recent_consumption_records)) {
    let reagent_data = data.recent_consumption_records.filter(item => {
      const urlParams = new URLSearchParams(window.location.search)
      const set = urlParams.get('set')
      if (data.configuration && Array.isArray(data.configuration)) {
        let settings = data.configuration[0]
        if (settings.hasOwnProperty(set)) {
          let curr_settings = settings[set]
          if (curr_settings['lab_name']) {
            let scope_list = curr_settings['lab_name']
            if (scope_list.indexOf(item.lis_eqpt__lab__name) > -1) {
              return true
            } else {
              return false
            }
          }
        }
      }

      return true
    })

    final_data = reagent_data.map(function(item) {
      return [
        item.barcode_product_name,
        item.barcode_product__spec_name,
        item.barcode_product__batch_name,
        item.barcode_product__validity_name,
        item.barcode_product__code,
        item.lis_eqpt__lab__name,
        item.lis_eqpt__name,
        item.created.substring(0, 10),
      ]
    })
  }

  let config = {
    // 产品名称，规格，批号，效期，条码，上机实验室，上机设备，上机人，上机日期
    header: ['产品名称', '规格', '批号', '效期', '条码', '上机实验室', '上机设备', '上机日期'],
    data: final_data,
    index: true,
    indexHeader: '序号',
    columnWidth: [
      width * 0.04,
      width * 0.21,
      width * 0.08,
      width * 0.08,
      width * 0.07,
      width * 0.08,
      width * 0.1,
      width * 0.2,
      width * 0.07,
    ],
    align: ['center', 'center', 'center', 'center'],
    rowNum: 6,
    headerHeight: height * 0.024,
    headerBGC: 'transparent',
    oddRowBGC: 'rgba(0, 44, 81, 0.8)',
    evenRowBGC: 'rgba(10, 29, 50, 0.8)',
  }
  return (
    <div
      style={{
        marginLeft: 0.03 * width,
        height: 0.3 * height,
        width: 0.93 * width,
      }}
      className={'table-container'}
    >
      <ScrollBoard config={config}></ScrollBoard>
    </div>
  )
}
